import { EMPTY, of } from 'rxjs';
import { delay, finalize, mergeMap, repeatWhen, takeWhile } from 'rxjs/operators';

export function repeat<T>(predicate: (value: T) => boolean, times = 3, milliseconds = 1000) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (_target: object, _key: string, descriptor: TypedPropertyDescriptor<any>) => {
        const originalMethod = descriptor.value;
        let retryAttempt: number = 0;
        let isFinished: boolean = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        descriptor.value = function (...args: any[]) {
            return originalMethod.apply(this, args).pipe(
                mergeMap((res: T) => {
                    retryAttempt++;
                    isFinished = retryAttempt === times || predicate(res);
                    return isFinished ? of(res) : EMPTY;
                }),
                repeatWhen(observable$ => {
                    return observable$.pipe(
                        delay(milliseconds * retryAttempt),
                        // eslint-disable-next-line rxjs/no-ignored-takewhile-value
                        takeWhile(() => !isFinished),
                    );
                }),
                finalize(() => {
                    retryAttempt = 0;
                    isFinished = false;
                }),
            );
        };
        return descriptor;
    };
}
